'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import UIScrollOverhang from './UIScrollOverhang';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import refObject from '../utils/propTypes/refObject';
import { toPx } from '../utils/Styles';

const isHorizontal = direction => direction === 'horizontal' || direction === 'both';

const isVertical = direction => direction === 'vertical' || direction === 'both';

const DefaultScrollContainer = styled.div.withConfig({
  displayName: "UIScrollContainer__DefaultScrollContainer",
  componentId: "sc-1h3g0g3-0"
})(["height:100%;width:100%;max-height:", ";max-width:", ";overflow-x:", ";overflow-y:", ";position:relative;"], props => toPx(props.maxHeight), props => toPx(props.maxWidth), props => isHorizontal(props.scrollDirection) ? 'auto' : 'hidden', props => isVertical(props.scrollDirection) ? 'auto' : 'hidden');
DefaultScrollContainer.propTypes = {
  children: PropTypes.node,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  scrollDirection: PropTypes.oneOf(['horizontal', 'vertical', 'both', 'none']).isRequired
};
DefaultScrollContainer.defaultProps = {
  scrollDirection: 'both'
};

class UIScrollContainer extends Component {
  constructor(...args) {
    super(...args);

    this.refCallback = ref => {
      const {
        scrollElementRef,
        connectDragSource,
        connectDropTarget
      } = this.props;
      if (!(scrollElementRef || connectDragSource || connectDropTarget)) return;
      const el = ref;

      if (scrollElementRef) {
        if (typeof scrollElementRef === 'function') {
          scrollElementRef(el);
        } else {
          scrollElementRef.current = el;
        }
      }

      if (connectDragSource) connectDragSource(el);
      if (connectDropTarget) connectDropTarget(el);
    };
  }

  render() {
    const _this$props = this.props,
          {
      children,
      maxHeight,
      maxWidth,
      ScrollContainer,
      scrollDirection
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "maxHeight", "maxWidth", "ScrollContainer", "scrollDirection", "scrollElementRef"]);

    return /*#__PURE__*/_jsx(UIScrollOverhang, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(ScrollContainer, {
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        ref: this.refCallback,
        scrollDirection: scrollDirection,
        children: children
      })
    }));
  }

}

UIScrollContainer.propTypes = Object.assign({}, UIScrollOverhang.propTypes, {}, DefaultScrollContainer.propTypes, {
  ScrollContainer: getComponentPropType(DefaultScrollContainer),
  scrollElementRef: PropTypes.oneOfType([refObject, PropTypes.func]),
  connectDropTarget: PropTypes.func,
  connectDragSource: PropTypes.func
});
UIScrollContainer.defaultProps = Object.assign({}, UIScrollOverhang.defaultProps, {}, DefaultScrollContainer.defaultProps, {
  ScrollContainer: DefaultScrollContainer
});
UIScrollContainer.displayName = 'UIScrollContainer';
export default UIScrollContainer;